import Router from 'vue-router';
import Home from '../pages/Home.vue';
import CookiePolicy from '../pages/CookiePolicy';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfConditions from '../pages/TermsOfConditions';
import Support from '../pages/Support';
import Faq from '../pages/Faq';
import Register from '../pages/Register';
import RegisterInvite from '../pages/RegisterInvite';
import PhoneVerify from '../components/register/PhoneVerify';
import PhoneVerifyInvite from '../components/register-invite/PhoneVerifyInvite';
import FirmInfoStep from '../components/register/FirmInfoStep';
import Billing from '../components/register/Billing';
import ProfilePhotoStep from '../components/register/ProfilePhotoStep';
import ProfilePhotoStepInvite from '../components/register-invite/ProfilePhotoStepInvite';
import ConfirmMail from '../pages/ConfirmMail';
import ConfirmPhone from '@/pages/ConfirmPhone';
import LoginInAccount from '../pages/LoginInAccount';
import LoginInAccountOtp from '../pages/LoginInAccountOtp';
import ResetPassword from '../pages/Reset-Password/ResetPasswordMessage';
import ResetPasswordForm from '../pages/Reset-Password/ResetPasswordForm';
import CreateNewPassword from '../pages/Reset-Password/CreateNewPassword';
import RegisterAccount from '../pages/RegisterAccount';
import RegisterAccountInvite from '../pages/RegisterAccountInvite';
import Profile from '../pages/Profile';
import Download from '../pages/Download';
import EditProfileTab from '../components/profile/EditProfileTab';
import FirmInfoTab from '../components/profile/FirmInfoTab';
import PasswordSecurityTab from '../components/profile/PasswordSecurityTab';
import Dashboard from '../pages/Dashboard';
import Contacts from '../pages/Contacts';
import InviteContact from '../pages/InviteContact';
import Cases from '../pages/Cases';
import ConfigureDevice from '../pages/ConfigureDevice';
import CreateCase from '../pages/CreateCase';
import Permissions from '../pages/Permissions';
import ProfileBilling from '../pages/Billing';
import BillingHistory from '../components/billing/BillingHistory';
import RegPack from '../components/billing/RegPack';
import Notifications from '../pages/Notifications';
import NotificationsFiles from '../components/notifications/NotificationsFiles';
import NotificationsCase from '../components/notifications/NotificationsCase';
import NotificationsClients from '../components/notifications/NotificationsClients';
import NotificationsTeam from '../components/notifications/NotificationsTeam';
import NotificationsPermission from '../components/notifications/NotificationsPermission';
import NotificationsBilling from '../components/notifications/NotificationsBilling';
import SoftwareSettings from '../pages/SoftwareSettings';
import ErrorPageNotFound from '../pages/ErrorPageNotFound';
import PermissionsRole from '../components/profile/PermissionsRole';
import PermissionsIndividual from '../components/profile/PermissionsIndividual';
import PermissionsCases from '../components/profile/PermissionsCases';
import PermissionsCaseItem from '../components/profile/PermissionsCaseItem';
import PrintInvoice from '../pages/PrintInvoice';
import Approved from '../components/invite-new/Approved';
import InviteNew from '../components/invite-new/InviteNew';
import ProcessingRequests from '../components/invite-new/ProcessingRequests';
import CaseDetails from '../components/cases/case/CaseDetails';
import CaseEmployeesTable from '../components/cases/case-employees/CaseEmployeesTable';
import CaseClientsTable from '../components/cases/case-clients/CaseClientsTable';
import CaseMessages from '../components/cases/case-messages/CaseMessages';
import CaseFilesTable from '../components/cases/case-files/CaseFilesTable';
import AssignCaseManager from '../components/cases/case-assign-manager/AssignCaseManager';
import CaseActions from '../components/cases/case-actions/CaseActions';
import CaseActionsPermission from '../components/cases/case-actions/CaseActionsPermission';
import CaseActionsTeam from '../components/cases/case-actions/CaseActionsTeam';
import CaseActionsClients from '../components/cases/case-actions/CaseActionsClients';
import CaseActionsFiles from '../components/cases/case-actions/CaseActionsFiles';
import CaseAssign from '../components/cases/case-assign/CaseAssign';
import ContactsEmployees from '../components/contacts/ContactsEmployees';
import ContactsClients from '../components/contacts/ContactsClients';
import ClientProfile from '../pages/ClientProfile';
import UserProfile from '../pages/UserProfile';
import AppVersions from '../pages/AppVersions';
import CaseInviteClient from '../components/cases/case-assign/CaseInviteClient';
import CaseExport from '../components/cases/case-export/CaseExport';
import PhoneConfirmInvite from '@/components/register/PhoneConfirmInvite';
import CaseEmails from '../components/cases/case-email/CaseEmail';
import CaseEmailList from '../components/cases/case-email/CaseEmailList';
import CaseMessagesMobileChats from '@/components/cases/case-messages/CaseMessagesMobileChats.vue';
import CaseMessagesEmails from '@/components/cases/case-messages/CaseMessagesEmails.vue';
import CaseMessagesMedia from '@/components/cases/case-messages/media/CaseMessagesMedia.vue';
import CaseMessagesApps from '@/components/cases/case-messages/CaseMessagesApps.vue';
import CaseEmailFolder from '@/components/cases/case-email/case-email-folders/CaseEmailFolder.vue';
import CaseEmailFolderList from '@/components/cases/case-email/case-email-folders/CaseEmailFolderList.vue';
import CaseEmailSpecificMessage from '@/components/cases/case-email/case-email-folders/CaseEmailSpecificMessage.vue';
import ClientSupport from '@/pages/ClientSupport.vue';
import CustodianSessionsList from '@/components/support/CustodianSessionsList.vue';
import CaseSettings from '@/components/cases/case-settings/CaseSettings.vue';
import CaseSettingsGeneral from '@/components/cases/case-settings/CaseSettingsGeneral.vue';
import CallLogs from '@/components/cases/case-messages/CaseMessagesCallLogs.vue';
import CaseMessagesContacts from '@/components/cases/case-messages/CaseMessagesContacts.vue';
import ProfileSecurityTab from '@/components/profile/ProfileSecurityTab.vue';
import ManagementPage from '@/pages/ManagementPage.vue';
import ManageKeysList from '@/components/management/ManageKeysList.vue';
import PhoneChangeTab from '@/components/profile/PhoneChangeTab.vue';
import EmailChangeTab from '@/components/profile/EmailChangeTab.vue';
import PmeSupport from '@/pages/PmeSupport.vue';
import SupportTopic from '@/components/support/SupportTopic.vue';
import AccessibilityPolicy from '@/pages/AccessibilityPolicy.vue';
import MessagesTaggingCommentsTab from '@/components/cases/case-messages/message-tags/MessagesTaggingCommentsTab.vue';
import MessagesTaggingMainTab from '@/components/cases/case-messages/message-tags/MessagesTaggingMainTab.vue';
import MessagesTaggingTab from '@/components/cases/case-messages/message-tags/MessagesTaggingTab.vue';
import MessagesTaggingPinnedTab from '@/components/cases/case-messages/message-tags/MessagesTaggingPinnedTab.vue';
import MessagesTaggingHighlightTab from '@/components/cases/case-messages/message-tags/MessagesTaggingHighlightTab.vue';
import MessagesTaggingRemindersTab from '@/components/cases/case-messages/message-tags/MessagesTaggingRemindersTab.vue';
import CaseSettingsCustodians from '@/components/cases/case-settings/CaseSettingsCustodians.vue';
import ComingSoon from '@/pages/ComingSoon.vue';
import PressRelease from '@/pages/PressRelease.vue';
import CaseNoMatchData from '@/components/cases/case-data/CaseNoMatchData.vue';
import NotificationsSources from '@/components/notifications/NotificationsSources.vue';
import store from '@/store';
import CaseSettingsExport from '@/components/cases/case-settings/CaseSettingsExport.vue';
import hasPermission from '@/utils/permission';
import {PATHS_PERMISSIONS} from '@/constants/const';
import ErrorPageNotAllowed from '@/pages/ErrorPageNotAllowed.vue';
import CaseSettingsContacts from '@/components/cases/case-settings/CaseSettingsContacts.vue';
import MediaTaggingMainTab from '@/components/cases/case-messages/media-tags/MediaTaggingMainTab.vue';
import MediaTaggingTab from '@/components/cases/case-messages/media-tags/MediaTaggingTab.vue';
import MediaTaggingPinnedTab from '@/components/cases/case-messages/media-tags/MediaTaggingPinnedTab.vue';
import MediaTaggingCommentsTab from '@/components/cases/case-messages/media-tags/MediaTaggingCommentsTab.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Home',
        },
        children: [
            {
                path: '/home/press-release',
                name: 'PressRelease',
                component: PressRelease,
            },
        ]
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
            title: 'Register',
        },
        children: [
            {
                path: 'phone-verify/*',
                name: 'PhoneVerify',
                component: PhoneVerify,
                meta: {
                    authorization: true
                },
            },
            {
                path: 'firm-information',
                name: 'FirmInfoStep',
                component: FirmInfoStep,
                meta: {
                    authorization: true
                },
                beforeEnter: (to, from, next) => {
                    let arr = JSON.parse(localStorage.getItem('step'));
                    if (arr !== null) {
                        if (to.name !== 'LoginInAccount' && arr.includes(2)) next();
                        else next({name: 'LoginInAccount'});
                    } else next({name: 'LoginInAccount'});
                }
            }, {
                path: 'billing',
                name: 'Billing',
                component: Billing,
                meta: {
                    authorization: true
                },
            },
            {
                path: 'user-photo',
                name: 'ProfilePhotoStep',
                component: ProfilePhotoStep,
                meta: {
                    authorization: true
                },
            },
        ]
    },
    {
        path: '/register-invite/',
        name: 'RegisterInvite',
        component: RegisterInvite,
        meta: {
            title: 'Register',
        },
        children: [
            {
                path: 'phone-verify/*',
                name: 'PhoneVerifyInvite',
                component: PhoneVerifyInvite,
                meta: {
                    authorization: true
                },
            },
            {
                path: 'phone-confirm/*',
                name: 'PhoneConfirmInvite',
                component: PhoneConfirmInvite,
            },
            {
                path: 'user-photo',
                name: 'ProfilePhotoStepInvite',
                component: ProfilePhotoStepInvite,
                meta: {
                    authorization: true
                },
            },
        ]
    },
    {
        path: '/cookie-policy',
        name: 'CookiePolicy',
        component: CookiePolicy,
        meta: {
            title: 'Cookie Policy',
        },
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        meta: {
            title: 'Privacy Policy',
        },
    },
    {
        path: '/accessibility-policy',
        name: 'AccessibilityPolicy',
        component: AccessibilityPolicy,
        meta: {
            title: 'Accessibility Policy',
        },
    },
    {
        path: '/faq',
        name: 'Faq',
        component: Faq,
        meta: {
            title: 'FAQ',
        },
    },
    {
        path: '/terms-of-conditions',
        name: 'TermsOfConditions',
        component: TermsOfConditions,
        meta: {
            title: 'Terms of Conditions',
        },
    },
    {
        path: '/confirm-mail',
        name: 'ConfirmMail',
        component: ConfirmMail,
        meta: {
            authorization: true,
            title: 'Confirm Mail',
        },
    },
    {
        path: '/confirm-phone',
        name: 'ConfirmPhone',
        component: ConfirmPhone,
        meta: {
            authorization: true,
            title: 'Confirm Phone',
        },
    },
    {
        path: '/login-in',
        name: 'LoginInAccount',
        component: LoginInAccount,
        meta: {
            authorization: true,
            title: 'Login',
        },
    },
    {
        path: '/login-in-otp',
        name: 'LoginInAccountOtp',
        component: LoginInAccountOtp,
        meta: {
            authorization: true,
            title: 'Login',
        },
    },
    {
        path: '/reset-password-form',
        name: 'ResetPasswordForm',
        component: ResetPasswordForm,
        meta: {
            authorization: true,
            title: 'Reset Password',
        },
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            authorization: true,
            title: 'Reset Password',
        },
    },
    {
        path: '/create-new-password/*',
        name: 'CreateNewPassword',
        component: CreateNewPassword,
        meta: {
            authorization: true,
            title: 'New Password',
        },
    },
    {
        path: '/register-account',
        name: 'RegisterAccount',
        component: RegisterAccount,
        meta: {
            authorization: true,
            title: 'Register',
        },
    },
    {
        path: '/register-account-invite/*',
        name: 'RegisterAccountInvite',
        component: RegisterAccountInvite,
        meta: {
            authorization: true,
            title: 'Register',
        },
    },
    {
        path: '/profile-user',
        name: 'Profile',
        component: Profile,
        meta: {
            requiresAuth: true,
            title: 'Profile',
        },
        children: [
            {
                path: '/profile-user',
                name: 'My profile',
                component: EditProfileTab,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'information',
                name: 'Information',
                component: FirmInfoTab,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'password',
                name: 'PasswordSecurity',
                component: PasswordSecurityTab,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'security',
                name: '2FASecurity',
                component: ProfileSecurityTab,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'phone',
                name: 'PhoneSecurity',
                component: PhoneChangeTab,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'email',
                name: 'EmailSecurity',
                component: EmailChangeTab,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            title: 'Dashboard',
        }
    },
    {
        path: '/team',
        redirect: '/team/employee',
        name: 'Team',
        component: Contacts,
        meta: {
            requiresAuth: true,
            title: 'Team',
        },
        children: [
            {
                path: 'employee',
                name: 'Team',
                component: ContactsEmployees,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'custodians',
                name: 'Custodians',
                component: ContactsClients,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/invite-new-contact',
        name: 'Invite contact',
        redirect: '/invite-new-contact/approved',
        component: InviteContact,
        meta: {
            requiresAuth: true,
            title: 'Invite',
        },
        children: [
            {
                path: 'invite-team',
                name: 'Send invitations',
                component: InviteNew,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'approved',
                name: 'Approved requests',
                component: Approved,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'processing-requests',
                name: 'Processing requests',
                component: ProcessingRequests,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/cases',
        name: 'Cases',
        component: Cases,
        meta: {
            requiresAuth: true,
            title: 'Cases',
        }
    },
    {
        path: '/cases/:slug',
        redirect: '/cases/:slug/users',
        name: 'case-details',
        component: CaseDetails,
        meta: {
            requiresAuth: true,
            title: 'Case Profile',
        },
        children: [
            {
                path: 'users',
                name: 'CaseEmployeesTable',
                component: CaseEmployeesTable,
                meta: {
                    requiresAuth: true,
                    noForceReload: true
                }
            },
            {
                path: 'clients',
                name: 'CaseClientsTable',
                component: CaseClientsTable,
                meta: {
                    requiresAuth: true,
                    noForceReload: true
                }
            },
        ]
    },
    {
        path: '/cases/:slug/matching',
        name: 'CaseNoMatchData',
        component: CaseNoMatchData,
        meta: {
            requiresAuth: true,
            noForceReload: true,
            title: 'Case No Match Data',
        }
    },
    {
        path: '/cases/:slug/messages',
        redirect: {name: 'Case messages mobile chats'},
        name: 'Messages',
        component: CaseMessages,
        meta: {
            requiresAuth: true,
            title: 'Case Messages',
        },
        children: [
            {
                path: 'chats',
                name: 'Case messages mobile chats',
                component: CaseMessagesMobileChats,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'chats/tagging',
                name: 'Messages tagging main tab',
                component: MessagesTaggingMainTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'chats/tagging/edit',
                name: 'Messages tagging tab',
                component: MessagesTaggingTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'chats/tagging/pinned',
                name: 'Messages tagging pinned tab',
                component: MessagesTaggingPinnedTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'chats/tagging/highlight',
                name: 'Messages tagging highlight tab',
                component: MessagesTaggingHighlightTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'chats/tagging/reminders',
                name: 'Messages tagging reminders tab',
                component: MessagesTaggingRemindersTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'chats/tagging/comments',
                name: 'Messages tagging comments tab',
                component: MessagesTaggingCommentsTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'emails',
                name: 'Case messages email list',
                component: CaseMessagesEmails,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'media',
                name: 'Case messages media list',
                component: CaseMessagesMedia,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'media/tagging',
                name: 'Media tagging main tab',
                component: MediaTaggingMainTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'media/tagging/edit',
                name: 'Media tagging tab',
                component: MediaTaggingTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'media/tagging/pinned',
                name: 'Media tagging pinned tab',
                component: MediaTaggingPinnedTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'media/tagging/comments',
                name: 'Media tagging comments tab',
                component: MediaTaggingCommentsTab,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'logs',
                name: 'Case messages call logs list',
                component: CallLogs,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'contacts',
                name: 'Case messages contacts list',
                component: CaseMessagesContacts,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'apps',
                name: 'Case messages apps list',
                component: CaseMessagesApps,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/cases/:slug/assign',
        name: 'Assign new Users to',
        component: CaseAssign,
        meta: {
            requiresAuth: true,
            title: 'Case Assign',
        }
    },
    {
        path: '/cases/:slug/invite',
        name: 'Invite',
        component: CaseInviteClient,
        meta: {
            requiresAuth: true,
            title: 'Case Invite',
        }
    },
    {
        path: '/cases/:slug/files',
        name: 'Files',
        component: CaseFilesTable,
        meta: {
            requiresAuth: true,
            title: 'Case Files',
        }
    },
    {
        path: '/cases/:slug/case-manager',
        name: 'Assign new Case Manager for',
        component: AssignCaseManager,
        meta: {
            requiresAuth: true,
            title: 'Assign Case Manager',
        }
    },
    {
        path: '/cases/:slug/export',
        name: 'Export',
        component: CaseExport,
        meta: {
            requiresAuth: true,
            title: 'Case Export',
        }
    },
    {
        path: '/cases/:slug/settings',
        redirect: '/cases/:slug/settings/general',
        name: 'Case Settings',
        component: CaseSettings,
        meta: {
            requiresAuth: true,
            title: 'Case Settings',
        },
        children: [
            {
                path: '/cases/:slug/settings/general',
                name: 'Case Settings',
                component: CaseSettingsGeneral,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: '/cases/:slug/settings/custodians',
                name: 'Case Settings',
                component: CaseSettingsCustodians,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: '/cases/:slug/settings/export',
                name: 'Case Settings',
                component: CaseSettingsExport,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: '/cases/:slug/settings/contacts',
                name: 'Case Settings',
                component: CaseSettingsContacts,
                meta: {
                    requiresAuth: true
                },
            }
        ]
    },
    {
        path: '/cases/:slug/case-actions',
        redirect: '/cases/:slug/case-actions/permission',
        name: 'case-actions',
        component: CaseActions,
        meta: {
            requiresAuth: true,
            title: 'Case Actions',
        },
        children: [
            {
                path: 'permission',
                name: 'Case Actions Permission',
                component: CaseActionsPermission,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'team',
                name: 'Case Actions Team',
                component: CaseActionsTeam,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'clients',
                name: 'Case Actions Custodians',
                component: CaseActionsClients,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'files',
                name: 'Case Actions Files',
                component: CaseActionsFiles,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/cases/:slug/emails',
        redirect: '/cases/:slug/emails/email-integration',
        name: 'E-mail integration wrapper',
        component: CaseEmails,
        meta: {
            requiresAuth: true,
            title: 'Case Emails',
        },
        children: [
            {
                path: 'email-integration',
                name: 'E-mail integration',
                component: CaseEmailList,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ':emailId',
                redirect: ':emailId/list',
                name: 'E-mail integration folder wrapper',
                component: CaseEmailFolder,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: 'list',
                        name: 'E-mail integration list',
                        component: CaseEmailFolderList,
                        meta: {
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'message/:messageId',
                        name: 'E-mail integration specific message',
                        component: CaseEmailSpecificMessage,
                        meta: {
                            requiresAuth: true
                        }
                    }
                ]
            },
        ]
    },
    {
        path: '/cases/:slug/management',
        name: 'Management',
        redirect: '/cases/:slug/management/custodians',
        component: ManagementPage,
        meta: {
            requiresAuth: true,
            title: 'Case Management',
        },
        children: [
            {
                path: 'custodians',
                name: 'Manage Custodians',
                component: ManageKeysList,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/cases/:slug/configure-device',
        name: 'Configure Device',
        component: ConfigureDevice,
        meta: {
            requiresAuth: true,
            title: 'Configure Device',
        }
    },
    {
        path: '/create-case',
        name: 'Create Case',
        component: CreateCase,
        meta: {
            requiresAuth: true,
            title: 'Create Case',
        }
    },
    {
        path: '/permissions',
        name: 'Permissions',
        component: Permissions,
        meta: {
            requiresAuth: true,
            title: 'Permissions',
        },
        children: [
            {
                path: 'role',
                name: 'Permissions Role',
                component: PermissionsRole,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'individual',
                name: 'Role Individual',
                component: PermissionsIndividual,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'individual/:user_id',
                name: 'Role Individual User',
                component: PermissionsIndividual,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'case',
                name: 'Permissions Case',
                component: PermissionsCases,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'case/:slug',
                name: 'Case',
                component: PermissionsCaseItem,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'case/:case_id/:user_id',
                name: 'Case Permission',
                component: PermissionsCaseItem,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/billing-account',
        name: 'Billing information',
        component: ProfileBilling,
        children: [
            {
                path: 'payment-history',
                name: 'Billing Payment history',
                component: BillingHistory,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'regPack',
                name: 'Billing RegPack',
                component: RegPack,
                meta: {
                    requiresAuth: true
                }
            },
        ],
        meta: {
            requiresAuth: true,
            title: 'Billing Information'
        }
    },
    {
        path: '/notifications',
        name: 'Notifications',
        redirect: '/notifications/files',
        component: Notifications,
        children: [
            {
                path: 'files',
                name: 'Notifications Files',
                component: NotificationsFiles,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'cases',
                name: 'Notifications Case',
                component: NotificationsCase,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'custodians',
                name: 'Notifications Custodians',
                component: NotificationsClients,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'team',
                name: 'Notifications Team',
                component: NotificationsTeam,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'permission',
                name: 'Notifications Permission',
                component: NotificationsPermission,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'billing',
                name: 'Notifications Billing',
                component: NotificationsBilling,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'sources',
                name: 'Notifications Sources',
                component: NotificationsSources,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/download',
        name: 'Download',
        component: Download,
        meta: {
            title: 'Download',
        },
    },
    {
        path: '/software-settings',
        name: 'SoftwareSettings',
        component: SoftwareSettings,
        meta: {
            title: 'Software Settings',
        },
    },
    {
        path: '*',
        name: 'ErrorPageNotFound',
        component: ErrorPageNotFound,
        meta: {
            title: 'Page not found',
        },
    },
    {
        path: '/not-allowed',
        name: 'ErrorPageNotAllowed',
        component: ErrorPageNotAllowed,
        meta: {
            title: 'Not allowed',
        },
    },
    {
        path: '/coming-soon',
        name: 'ComingSoon',
        component: ComingSoon,
        meta: {
            title: 'Coming Soon',
        },
    },
    {
        path: '/print-invoice',
        name: 'PrintInvoice',
        component: PrintInvoice,
    },
    {
        path: '/get-support',
        name: 'Support',
        component: Support,
        meta: {
            title: 'Support',
        },
    },
    {
        path: '/app-version/*',
        name: 'App Versions',
        component: AppVersions,
        meta: {
            title: 'App Versions',
        },
    },
    {
        path: '/client-profile/:slug',
        name: 'Custodian Profile',
        component: ClientProfile,
        meta: {
            requiresAuth: true,
            title: 'Custodian Profile',
        }
    },
    {
        path: '/user-profile/:slug',
        name: 'User Profile',
        component: UserProfile,
        meta: {
            requiresAuth: true,
            title: 'User Profile',
        }
    },
    {
        path: '/pme-support',
        name: 'PME Support',
        component: PmeSupport,
        meta: {
            requiresAuth: true,
            title: 'PME Support',
        },
        children: [
            {
                path: 'topic/:topicName/:postName',
                name: 'Support Topic',
                component: SupportTopic,
                meta: {
                    requiresAuth: true,
                    noForceReload: true
                }
            }
        ]
    },
    {
        path: '/cases/:slug/custodian-support',
        name: 'Client Support',
        redirect: '/cases/:slug/custodian-support/activity',
        component: ClientSupport,
        meta: {
            title: 'Custodian Support',
        },
        children: [
            {
                path: 'activity',
                name: 'Custodian Support',
                component: CustodianSessionsList,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/management',
        name: 'Management',
        redirect: '/management/custodians',
        component: ManagementPage,
        meta: {
            title: 'Management',
        },
        children: [
            {
                path: 'custodians',
                name: 'Manage Custodians',
                component: ManageKeysList,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

];

export const router = new Router({
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    mode: 'history',
    routes,
    linkActiveClass: 'active',
});

function setPageTitle(to) {
    const nearestWithTitle = to.matched
        .slice() // clone it just in case
        .reverse()
        .find(r => r.meta && r.meta.title);

    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    }
}

function checkPermission(to, next) {
    const pagePermission =
        Object.values(PATHS_PERMISSIONS)
            .map(page => ({
                ...page,
                path: page.path.replaceAll('CASE_ID', to.params.slug)
            }))
            .find(page => to.path === page.path);

    if (!pagePermission || hasPermission([pagePermission.permission])) {
        setPageTitle(to);
        return next();
    } else {
        return next('/not-allowed');
    }
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('isLogged') == null) {
            return next('/login-in');
        } else {
            return checkPermission(to, next);
        }
    } else if (to.matched.some(record => record.meta.authorization)) {
        if (localStorage.getItem('isLogged') !== null) {
            document.title = 'Dashboard';
            return next('/dashboard');
        } else {
            return checkPermission(to, next);
        }
    } else {
        setPageTitle(to);
        return next();
    }
});

router.afterEach((to, from) => {
    const decodedToPath = decodeURI(to.path);

    if (decodedToPath === decodeURI(from.path)) {
        if (store.state.routerHistory.navigatingHistory) {
            store.commit('routerHistory/SET_NAVIGATING_HISTORY', false);
        }
        return;
    }

    if (!store.state.routerHistory.navigatingHistory) {
        const {currentIndex, visitedRoutes} = store.state.routerHistory;

        if (visitedRoutes.length && visitedRoutes[currentIndex] === decodedToPath) {
            return;
        }

        if (currentIndex < visitedRoutes.length - 1) {
            const nextForwardRoute = visitedRoutes[currentIndex + 1];
            if (nextForwardRoute === decodedToPath) {
                store.commit('routerHistory/GO_FORWARD');
            } else {
                store.commit('routerHistory/SPLICE_FORWARD_ROUTES');
                store.commit('routerHistory/ADD_ROUTE', decodedToPath);
            }
        } else {
            store.commit('routerHistory/ADD_ROUTE', decodedToPath);
        }
    }

    if (store.state.routerHistory.navigatingHistory) {
        store.commit('routerHistory/SET_NAVIGATING_HISTORY', false);
    }
});

export default router;
